import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { fetchData } from "../../helpers/getData/fetchData"
import { CreateRound } from "./CreateRound"


export const GetStartupDataRound = () => {

    const { t } = useTranslation('global')
    const [startupList, setStartupList] = useState('isLoading')
    const [vehiclesList, setVehicles] = useState('isLoading')

    useEffect(() => {
        fetchData(setStartupList, '/startups', t);
        fetchData(setVehicles, '/vehicle/nameList', t);
    }, [t])

    return (
        <>
            {
                (startupList !== 'isLoading' && vehiclesList !== 'isLoading') &&
                <CreateRound startupList={startupList} vehiclesList={vehiclesList} />
            }
        </>
    )
}